// src/services/authApi.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Import the custom axiosBaseQuery
import { AUTH_LOGIN, AUTH_LOGOUT, CHANGE_PASSWORD } from "../../config/constants";

const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: AUTH_LOGIN, // Adjust this to your login endpoint
        method: "POST",
        data: credentials, // Adjust body to be 'data' for axios
      }),
    }),
    changePassword: builder.mutation({
      query: ({ data }) => ({
        url: `${CHANGE_PASSWORD}`,
        method: "PUT",
        data: data,
      }),
    }),
    // Add other endpoints here (if needed)
    logout: builder.mutation({
      query: (data) => ({
        url: AUTH_LOGOUT,
        method: "POST",
      }),
    }),
  }),
});

// Export hooks for usage in functional components
export const { useLoginMutation, useLogoutMutation , useChangePasswordMutation } = authApi;

// Export the reducer to be included in the store
export default authApi;
